<template>
    <div id="base-app">
        <v-navigation-drawer
            class="htns-navbar"
            :clipped="$vuetify.breakpoint.lgAndUp"
            fixed
            app
            dark
            color="#595957"
        >
            <v-list-item style="margin-bottom: 32px;">
                <v-list-item-content>
                    <v-avatar size="80" tile>
                        <v-img
                            :src="require('../assets/temasek-club-logo.jpg')"
                            :lazy-src="
                                require('../assets/temasek-club-logo.jpg')
                            "
                            :min-width="80"
                            :max-width="80"
                        ></v-img>
                    </v-avatar>
                    <v-list-item-title class="title"></v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list dense>
                <v-list-item to="/">
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item to="/feedback">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Feedback</v-list-item-title>
          </v-list-item-content>
                </v-list-item>-->

                <!-- <v-list-item to="/rating">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Ratings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/rating/id">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Reports</v-list-item-title>
          </v-list-item-content>
                </v-list-item>-->


                <v-list-group
                    prepend-icon="mdi-emoticon-outline"
                    value="true"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Smiley Tool</v-list-item-title>
                    </template>

                    <v-list-item to="/settings/department">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-briefcase-variant</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Departments</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item to="/settings/category">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-cards-variant</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Categories</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/settings/location">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-map-marker</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Locations</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/settings/device">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-tablet-cellphone</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Devices</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    prepend-icon="mdi-comment-quote-outline"
                    value="true"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Feedback Tool</v-list-item-title>
                    </template>

                    <v-list-item to="/feedback-tool/event">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-calendar</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Events</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/feedback-tool/form">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-form-select</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Forms</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group prepend-icon="mdi-cog-outline" value="true">
                    <template v-slot:activator>
                        <v-list-item-title>Settings</v-list-item-title>
                    </template>

                    <v-list-item to="/user">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-account-group</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title
                                >Users Management</v-list-item-title
                            >
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/my-account">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>My Account</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- <v-list-item to="/settings/email" disabled>
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-at</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title
                                >Email Settings</v-list-item-title
                            >
                        </v-list-item-content>
                    </v-list-item> -->

                    <v-list-item to="/settings/tool">
                        <v-list-item-icon class="ml-3 mr-5">
                            <v-icon>mdi-hammer-wrench</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Tool Settings</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item to="/settings/feedback-tool">
            <v-list-item-icon></v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Feedback Tool</v-list-item-title>
            </v-list-item-content>
                    </v-list-item>-->
                </v-list-group>
            </v-list>

            <template v-slot:append>
                <div class="pa-2">
                    <v-btn block color="red" dark @click="logout">Logout</v-btn>
                </div>
            </template>
        </v-navigation-drawer>
        <v-content>
            <router-view></router-view>
        </v-content>
    </div>
</template>

<script>
import { AUTH_LOGOUT } from "../store/actions/auth";

export default {
    methods: {
        logout: function () {
            this.$store
                .dispatch(AUTH_LOGOUT)
                .then(() => this.$router.push("/login"));
        },
    },
};
</script>

<style>
.theme--light.v-application {
    background-color: #a8a5d414;
}
.theme--dark.v-list {
    background: #595957 !important;;
    color: #fff;
}
.theme--dark.v-icon {
    color: inherit;
}
</style>